import type { QueryParameters } from '../types/NavigateOptions';
import { getQueryParamsFromUrl } from './useQueryParams';

export function splitPathFromQueryParams(path: string): [string, QueryParameters] {
    if (path.match(/\?$/)) {
        return [path, {}];
    }
    if (!path.match(/\?[^/]/)) {
        return [path, {}];
    }

    const splitPath = path.split('?');
    return [
        splitPath.slice(0, splitPath.length - 1).join('?'),
        getQueryParamsFromUrl(splitPath[splitPath.length - 1] ?? '', { parseArrays: true }),
    ];
}

export function returnQueryParamAsArray(queryParams?: string | string[]): string[] | undefined {
    if (Array.isArray(queryParams)) {
        return queryParams;
    }
    if (queryParams === undefined) {
        return queryParams;
    }
    return [queryParams];
}
